import '.bn{position:relative;}.ssr-plugin'
import '.i6{width:64px;}.ssr-plugin'
import '.i7{height:64px;}.ssr-plugin'
import '.c3{flex-shrink:0;}.ssr-plugin'
import '.h{position:absolute;}.ssr-plugin'
import '.i8{bottom:-4px;}.ssr-plugin'
import '.cn{right:-4px;}.ssr-plugin'
import '.d9{border-radius:50%;}.ssr-plugin'
import '.i9{border:2px solid var(--shades-white);}.ssr-plugin'
import '.l{overflow:hidden;}.ssr-plugin'
import '.ia{width:32px;}.ssr-plugin'
import '.ib{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="bn i6 i7 c3"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="h i8 cn d9 i9 l ia ib"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
